/**
 * @ngdoc enum
 * @name mx.shell.ActionUiZone
 * @module mx.shell
 *
 * @description
 * Represents possible action visibility variants depends on UI
 */
export enum ActionUiZone {
	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#SidePanel
	 *
	 * @description
	 * Action is visible only in dialogs
	 */
	SidePanel = 0,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#EditDialog
	 *
	 * @description
	 * Action is visible only in Edit dialogs
	 */
	EditDialog = 1,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#Application
	 *
	 * @description
	 * Action is visible in the highest part of Application near `avatar`
	 */
	Application = 2,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#SearchPage
	 *
	 * @description
	 * Action is visible only on `search pages` as FAB button
	 */
	SearchPage = 3,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#AvatarMenu
	 *
	 * @description
	 * Action is visible only in `Avatar Menu`
	 */
	AvatarMenu = 4,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#Toolbar
	 *
	 * @description
	 * Action is visible on the toolbar, right side from `breadcrumbs`
	 */
	Toolbar = -1000 /* Obsolete, not supported UI zone */,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionUiZone#LandingPage
	 *
	 * @description
	 * Action is visible only on `landing pages`
	 */
	LandingPage = -2000 /* Obsolete, not supported UI zone */,

	Dashboard = 5,
}
